import { ResponsivePie } from "@nivo/pie";
import "./ChartTooltip.css";
import { useEffect, useState, useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const PieChart = ({ data }) => {
  const [pieChartData, setPieChartData] = useState([]);
  const { getAlterColor } = useContext(themeContext);

  let total = 0;
  useEffect(() => {
    data.forEach(d => {
      total += d.value;
    })
    const processedData = data.map(d => {
      let per = ((d.value / total)*100).toFixed(2);
      return {
        ...d, id: d.id + " (" + per +"%)"  
      }
    })
    setPieChartData(processedData);
  }, [data])

  return (
    <ResponsivePie
      data={pieChartData}
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      colors={{ scheme: 'set2' }}
      borderWidth={1}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      arcLinkLabelsSkipAngle={1}
      arcLinkLabelsTextColor={getAlterColor("rgb(255,255,255)","#000")}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={1}
      arcLabelsTextColor={getAlterColor("#ffffff","#000")}
      arcLinkLabelsDiagonalLength={36}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: getAlterColor("rgba(255, 255, 255, 0.3)","#000") ,
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: getAlterColor("rgba(255, 255, 255, 0.3)","#000") ,
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      tooltip={(e) => {
        return (
          <div
            className="tooltip-container"
            style={{ transform: `translate(${e.absX},${e.absY})` }}
          >
            <div className="tooltip-container_in">
              <div className="tooltip-container_in__inside">
                <span
                  style={{
                    display: "block",
                    width: "12px",
                    height: "12px",
                    background: e.datum.color,
                    marginRight: "7px",
                  }}
                ></span>
                <span style={{ color: "black" }}>
                  {e.datum.label} <strong> {e.datum.value}</strong>
                </span>
              </div>
            </div>
          </div>
        );
      }}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 80,
          itemsSpacing: 15,
          itemWidth: 100,
          itemHeight: 25,
          itemTextColor: getAlterColor("rgba(255, 255, 255, 0.8)","#000"),
          itemDirection: "left-to-right",
          itemOpacity: 1,
          symbolSize: 25,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: getAlterColor("#ffffff","#000"),
              },
            },
          ],
        },
      ]}
    />
  );
};

export default PieChart;
